export const initialState = {
  facilityHeader: {
    documentDate: new Date().toISOString(),
    validFrom: new Date().toISOString(),
    validUntil: new Date().toISOString(),
    clientName: "",
    partnerName: ""
  },
  isSaving: false,
  isDirty: false,
  isTransfering: false,
  loading: false,
  loaded: false
};

export const reducer = (state, action) => {
  switch (action.type) {
    case "OnInitState":
      return onInitState(state, action);
    case "OnHeaderSaving":
      return onHeaderSaving(state);
    case "OnHeaderSaveFailed":
      return onHeaderSaveFailed(state);
    case "OnHeaderSaved":
      return onHeaderSaved(state);
    case "OnTransferFacilityToERPStarted":
      return OnTransferFacilityToERPStarted(state);
    case "OnTransferFacilityToERPFailed":
      return OnTransferFacilityToERPFailed(state);
    case "OnTransferFacilityToERPSucceeded":
      return OnTransferFacilityToERPSucceeded(state, action);
    case "OnHeaderValuesChanged":
      return onHeaderValuesChanged(state, action);

    default:
      return state;
  }
};

const onInitState = (state, action) => {
  const { facilityHeader } = action;
  return {
    ...state,
    facilityHeader: facilityHeader
  };
};

const onHeaderSaving = state => {
  return {
    ...state,
    isSaving: true
  };
};

const onHeaderSaveFailed = state => {
  return {
    ...state,
    isSaving: false
  };
};

const onHeaderSaved = state => {
  return {
    ...state,
    isSaving: false,
    isDirty: false
  };
};

const OnTransferFacilityToERPStarted = state => {
  return {
    ...state,
    isTransfering: true
  };
};

const OnTransferFacilityToERPFailed = state => {
  return {
    ...state,
    isTransfering: false
  };
};

const OnTransferFacilityToERPSucceeded = (state, action) => {
  const { chDocumentId, chSiteId } = action.eventBody;
  return {
    ...state,
    isTransfering: false,
    facilityHeader: {
      ...state.facilityHeader,
      chDocumentId: chDocumentId,
      chSiteId: chSiteId
    }
  };
};

const onHeaderValuesChanged = (state, action) => {
  const { propertyName, value } = action;
  return {
    ...state,
    facilityHeader: {
      ...state.facilityHeader,
      [propertyName]: value
    },
    isDirty: true
  };
};
